import type { ReactNode } from 'react';
import { MissingNetworkErrorNotifierError } from './errors';

type NetworkErrorNotifier = (content: ReactNode) => void;

let networkErrorNotifier: NetworkErrorNotifier | null = null;

export const registerNetworkErrorNotifier = ({ notifier }: { notifier: NetworkErrorNotifier }) => {
  networkErrorNotifier = notifier;
};

export const notifyNetworkError = (content: ReactNode) => {
  if (!networkErrorNotifier) {
    throw new MissingNetworkErrorNotifierError();
  }

  networkErrorNotifier(content);
};
